const EMBEDDED_STYLE_PATTERN = /<style[^>]*>([\s\S]*?)<\/style>/gi

export function extractMarkdownEmbeddedStyles(content: string): {
  styles: string
  content: string
} {
  const styles: string[] = []
  const stripped = content.replace(EMBEDDED_STYLE_PATTERN, (_, css: string) => {
    styles.push(css.trim())
    return ''
  })

  return {
    styles: styles.join('\n'),
    content: stripped.trim(),
  }
}
